import client from './client';
import qs from 'qs';

const eqpUrl = '/api/v1/eqp';

// ============================= 장비 기본정보 =============================

export const getEqpList = (params) =>
  client.get(`${eqpUrl}/list?${qs.stringify(params)}`);

export const getEqp = (eqpUuid) =>
  client.get(`${eqpUrl}/info/${eqpUuid}`);

export const addEqp = (data) =>
  client.post(`${eqpUrl}/info`, data);

export const editEqp = (eqpUuid, data) =>
  client.put(`${eqpUrl}/info/${eqpUuid}`, data);

export const removeEqp = (eqpUuid) =>
  client.delete(`${eqpUrl}/info/${eqpUuid}`);

// ============================= 운영이력 (통합) =============================

export const getLogList = (params) =>
  client.get(`${eqpUrl}/log/list?${qs.stringify(params)}`);

export const getLog = (logUuid) =>
  client.get(`${eqpUrl}/log/info/${logUuid}`);

export const addLog = (data) =>
  client.post(`${eqpUrl}/log/info`, data);

export const editLog = (logUuid, data) =>
  client.put(`${eqpUrl}/log/info/${logUuid}`, data);

export const removeLog = (logUuid) =>
  client.delete(`${eqpUrl}/log/info/${logUuid}`);

// ============================= KPI 집계 =============================

export const getMonthlySummary = (params) =>
  client.get(`${eqpUrl}/log/summary?${qs.stringify(params)}`);

// ============================= 예상 가동시간 =============================

export const getPlanList = (params) =>
  client.get(`${eqpUrl}/plan/list?${qs.stringify(params)}`);

export const savePlan = (data) =>
  client.post(`${eqpUrl}/plan/info`, data);

export const removePlan = (planUuid) =>
  client.delete(`${eqpUrl}/plan/info/${planUuid}`);

// ============================= 기준시간(계획 가동시간) 설정 =============================

export const getStdTime = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/std-time`);

export const saveStdTime = (eqpUuid, data) =>
  client.put(`${eqpUrl}/${eqpUuid}/std-time`, data);

// 회사 기본값으로 되돌리기(덮어쓰기 삭제)
export const revertStdTime = (eqpUuid) =>
  client.delete(`${eqpUrl}/${eqpUuid}/std-time`);
